import { render, staticRenderFns } from "./CollectionCallReport.vue?vue&type=template&id=708ca07b&scoped=true"
import script from "./CollectionCallReport.vue?vue&type=script&lang=js"
export * from "./CollectionCallReport.vue?vue&type=script&lang=js"
import style0 from "./CollectionCallReport.vue?vue&type=style&index=0&id=708ca07b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ca07b",
  null
  
)

export default component.exports